import { t, currentLang } from 'translations'
import { store } from 'store/reducers'

type GetDepartmentNames = (departmentArray: Array<string | MData.Department>, options?: { key?: string; delimiter?: string }) => string

export const getDepartmentNames: GetDepartmentNames = (departmentArray = [], { key = '_id', delimiter = ' - ' } = {}) => {
  return departmentArray
    .map(department => {
      return typeof department === 'object' ? getDepartmentName(department[key]) : getDepartmentName(department)
    })
    .join(delimiter)
}

type GetDepartmentName = (departmentId: string) => string

export const getDepartmentName: GetDepartmentName = departmentId => {
  const {
    resources: { departmentsById }
  } = store.getState() as MStore.RootState

  if (!departmentsById[departmentId]) return t('components.DEPARTMENT_DELETED')

  return departmentsById[departmentId][`name${currentLang(true)}`]
}
